import Styled from './error.module.css'
import { Link } from 'react-router-dom'
import imageError from '../../Assets/error-404.svg'

function Error() {
    return (
        <section className={Styled.container}>
            <img src={imageError} alt="Pagina não encontrada" />
            <p>Pagina não encontrada!</p>
            <Link to="/">Ir para Home</Link>
        </section>
    )
}

export default Error